import React from 'react';
import TransactionDataTable from './TransactionDataTable';
import TransactionSourceHeader from './TransactionSourceHeader';

const TransactionItemDetails = ({
    item,
    sourceName,
    title,
    refField,
    setShowInvoiceDetails
}) => {
    return (
        <div>
            <div style={{ width: '100%', marginTop: 21 }}>
                <TransactionSourceHeader
                    item={item}
                    sourceName={sourceName}
                    title={title}
                    refField={refField}
                    setShowInvoiceDetails={setShowInvoiceDetails}
                />
            </div>

            <div style={{ marginLeft: 11, width: '98.7%', marginTop: 9 }}>
                <TransactionDataTable item={item} />
            </div>
        </div>
    );
};

export default TransactionItemDetails;
